import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useTranslation } from 'react-i18next';
import { DEFAULT_LANG } from '@/i18n';
import { pickI18nString } from '@/lib/i18nUtils';

export const useFocusAreasData = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language || DEFAULT_LANG;
  return useQuery({
    queryKey: ['focus-areas', lang],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('focus_areas')
        .select('id, name, name_i18n, description, description_i18n, icon, is_popular')
        .order('is_popular', { ascending: false })
        .order('name', { ascending: true });

      if (error) throw error;

      return (
        data?.map((fa: any) => ({
          id: fa.id,
          name: pickI18nString(fa.name_i18n, fa.name, lang, DEFAULT_LANG),
          description: pickI18nString(fa.description_i18n, fa.description, lang, DEFAULT_LANG),
          icon: fa.icon,
          isPopular: fa.is_popular,
        })) || []
      );
    },
  });
};

export const useQuestionTypesData = () => {
  const { i18n } = useTranslation();
  const lang = i18n.language || DEFAULT_LANG;
  return useQuery({
    queryKey: ['question-types', lang],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('question_types')
        .select('id, name, name_i18n, description, description_i18n, icon')
        .order('name');

      if (error) throw error;

      return (
        data?.map((qt: any) => ({
          id: qt.id,
          name: pickI18nString(qt.name_i18n, qt.name, lang, DEFAULT_LANG),
          description: pickI18nString(qt.description_i18n, qt.description, lang, DEFAULT_LANG),
          icon: qt.icon,
        })) || []
      );
    },
  });
};